import React from 'react'
// import backimg1 from './images/back.jpg'
import classNames from 'classnames'
import ScrollAnimation from 'react-animate-on-scroll'
import MyCard from './MyCard'
import './styles/Home.css'
import httpClient from './myapi'
import Logo from './images/logo'
import Youtube from './Youtube';
import Notice from './Notice'
import PaithaniPark from './images/pp';
import VisitorCount from './VisitorCount';
import MyCarousel from './MyCarousel';

const _webserver = httpClient.WebServer + '/imgs';

const cardData = [
  {
    img: _webserver + '/1.jpg', alt: '',
    title: 'प्युअर पैठणी ', text: 'This paithani saries handcrafted in yeola.', animDuration: 1
  },
  {
    img: _webserver + '/2.jpg', alt: '',
    title: 'प्युअर ब्रॉकेड पैठणी ', text: 'Some text here..', animDuration: 1.5
  },
  {
    img: _webserver + '/3.jpg', alt: '',
    title: 'सेमी पैठणी ', text: 'Some text here..', animDuration: 1.8
  },
  {
    img: _webserver + '/4.jpg', alt: '',
    title: 'फॅन्सी सारीज', text: 'Some text here..', animDuration: 2
  }
]
class Home extends React.Component {
  constructor() {
    super()
    this.state = {
      imgload: false, 
      slides: []
    }
    this.imgLoaded = this.imgLoaded.bind(this)
  }
  imgLoaded() {
    this.setState({
      imgload: true
    })
  }
  componentDidMount(){
    httpClient.get('/getSlides.php').then(res =>{
      console.log(res);
      
        this.setState({ slides: res});
    });
  }
  render() {
    return (
      <div>
        <div id="main-img-container">
          <div className="saint-name-holder">
            <div className="saint-name">
              श्रीराम समर्थ &nbsp; || &nbsp; जय जय रघुवीर समर्थ &nbsp; || &nbsp; श्री सदगुरु कृपा
          </div>
          </div>
          <div className={classNames("back-blur", { "vhidden": this.state.imgload })}></div>
          <div className="image-overlay">
            <div className="name-main-container">
              <div className="name-container">
                {this.state.imgload &&
                  <div>
                    <ScrollAnimation animateIn="fadeInUp" duration={.4}>
                      <Logo fill="#fff" />
                    </ScrollAnimation>
                    <ScrollAnimation animateIn="fadeInUp" delay={300} duration={.5}>
                      <PaithaniPark fill='#f96e0a' />
                    </ScrollAnimation>
                  </div>
                }
              </div>
            </div>
            <div style={{ marginTop: '26px' }}>
              <Notice />
            </div>
          </div>
          <img onLoad={this.imgLoaded} className="sharpened" src={_webserver + '/back.jpg'} alt="back" />
        </div>

        <div className="mycarousel-big">
          <MyCarousel slides={this.state.slides}/>
        </div>
        <div className="vertical-space"></div>
        <div className="card-row">
          <div className="card-col">
            <MyCard data={cardData[0]} />
            <MyCard data={cardData[1]} />
          </div>
          <div className="card-col">
            <MyCard data={cardData[2]} />
            <MyCard data={cardData[3]} />
          </div>
        </div>
        <div className="vertical-space"></div>

        <Youtube />
        
        <VisitorCount />
      </div>
    )
  }
}

export default Home;


// WEBPACK FOOTER //
// ./src/Home.jsx